import { SET_GRID_DATA } from "../actions/gridActions";

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

const gridReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GRID_DATA:
      return { ...state, data: action.payload, status: "success" };
    default:
      return state;
  }
};

export default gridReducer;
